module.exports = __webpack_public_path__ + "media/vue/assets/images/icons/sephora-logo-958a1bfa76916f5206453ee6eb3faafd.svg";